import type { Timestamp } from "@firebase/firestore-types";
import type { AssignedSupervisors } from "../account/assignedSupervisors.js";
import type { Account } from "../account/models.js";

export const accountOrganizationInvitationsFullPath = "accountOrganizationInvitations";
export const accountOrganizationInvitationFullPath = (organizationInvitationId: string): string =>
  `${accountOrganizationInvitationsFullPath}/${organizationInvitationId}`;

/**
 * A supervisor org asks to supervise a self-onboarded Treezor account. The supervisor org cannot read the account
 * until the account holder signs the tripartite contract: `settings` are applied to the account at
 * that point, then the organization invitation is deleted.
 */
export type AccountOrganizationInvitation = {
  supervisorOrgId: string;
  supervisorOrgName: string;
  accountId: string;
  companyName: string;
  siren: string;
  status: "pending" | "refused";
  contractTemplateId: string;
  envelopeId: string;
  settings: {
    assignedSupervisors: AssignedSupervisors;
    transferAmountThreshold: number | null;
    notifications: NonNullable<Account["notifications"]>;
  };
  invitedBy: string;
  createdAt: Timestamp;
  refusedAt?: Timestamp;
};
